<template>
    <div>
      <a href="#" @click="modal = !modal" style="color: #f79567"> <i class="feather icon-user-plus"></i> Registrarme </a>
      <b-modal v-model="modal"
        title="Registro de Usuario"
        header-bg-variant="secondary"
        header-text-variant="white"
        scrollable
        @close="close"
        hide-footer
        no-close-on-backdrop
        no-close-on-esc
        size="lg">

          <b-overlay  :show="loading" rounded="sm">
            <div class="container-fluid ">
              <form  method="POST" autocomplete="off" @submit.prevent="submitForm">
                <div class="row bg-text-d pt-1 pb-1">
                  <div class="form-group col-md-6">
                    <label for="first_name"><b>Nombre&nbsp;<span class="asterisk">*</span></b></label>
                    <input v-model="form.first_name" type="text" class="form-control " id="first_name" name="first_name" placeholder="Nombre">
                    <span v-if="first_nameValid" class="text-danger validField"><b>El campo Nombre es requerido.</b></span>
                  </div>

                  <div class="form-group col-md-6">
                    <label for="last_name"><b>Apellidos&nbsp;<span class="asterisk">*</span></b></label>
                    <input v-model="form.last_name" type="text" class="form-control " id="last_name" name="last_name" placeholder="Apellidos">
                    <span v-if="last_nameValid" class="text-danger validField"><b>El campo Apellidos es requerido.</b></span>
                  </div>

                  <div class="form-group col-md-6">
                    <label for="documenttype_id"><b>Tipo de Documento&nbsp;<span class="asterisk">*</span></b></label>
                    <select v-model="form.documenttype_id" class="form-control" id="documenttype_id" name="documenttype_id">
                      <option :value="null">Seleccione...</option>
                      <option v-for="type in documenttypes" :key="type.value" :value="type.value">{{ type.label }}</option>
                    </select>
                    <span v-if="documenttype_idValid" class="text-danger validField"><b>El campo Tipo de Documento es requerido.</b></span>
                  </div>

                  <div class="form-group col-md-6">
                    <label for="document_number"><b>N&uacute;mero de Documento&nbsp;<span class="asterisk">*</span></b></label>
                    <input v-model="form.document_number" type="text" class="form-control " id="document_number" name="document_number" :placeholder="isRut ? 'Ej: 20347878-K' : 'Número de Documento'">
                    <span v-if="document_numberValid" class="text-danger validField"><b>El campo Número de Documento es requerido.</b></span>
                    <span v-if="document_numberRut" class="text-danger validField"><b>El Número de Documento no es un RUT válido. Ejemplo: 20347878-K.</b></span>
                    <span v-if="userUsed" class="text-danger validField"><b>Ya existe una cuenta con estos datos.</b></span>
                  </div>

                  <div class="form-group col-md-6">
                    <label for="usertype"><b>Tipo Usuario</b></label>
                    <input type="text" class="form-control" id="usertype" value="Estudiante" readonly>
                  </div>

                  <div class="form-group col-md-6">
                    <label for="email"><b>Correo Electrónico&nbsp;<span class="asterisk">*</span></b></label>
                    <input v-model="form.email" type="email" class="form-control " id="email" name="email" placeholder="Correo Electrónico">
                    <span v-if="emailValid" class="text-danger validField"><b>El campo Correo Electrónico  es requerido.</b></span>
                    <span v-if="emailUsed" class="text-danger validField"><b>Este Correo Electrónico ya esta resgistrado.</b></span>
                  </div>

                  <div class="form-group col-md-6">
                    <label for="email_confirmation"><b>Confirmar Correo Electrónico&nbsp;<span class="asterisk">*</span></b></label>
                    <input v-model="form.email_confirmation" type="email" class="form-control " id="email_confirmation" name="email_confirmation" placeholder="Confirmar Correo Electrónico">
                    <span v-if="email_confirmationValid" class="text-danger validField"><b>El campo Confirmar Correo Electrónico es requerido.</b></span>
                    <span v-if="email_compareValid" class="text-danger validField"><b>Los Correos Electrónicos no coinciden</b></span>
                  </div>

                  <div class="form-group col-md-6">
                    <label for="password"><b>Contraseña&nbsp;<span class="asterisk">*</span></b></label>
                    <input v-model="form.password" :type="passwordType" @input="typeInput" class="form-control " id="password" name="password" placeholder="Contraseña">
                    <span v-if="passwordValid" class="text-danger validField"><b>El campo Contraseña es requerido.</b></span>
                    <span v-if="passwordLength" class="text-danger validField"><b>La Contraseña de ser mayor 8 caracteres</b></span>
                  </div>

                  <div class="form-group col-md-6">
                    <label for="password_confirmation"><b>Confirmar Contraseña&nbsp;<span class="asterisk">*</span></b></label>
                    <input v-model="form.password_confirmation" :type="passwordCType" @input="typeInput" class="form-control " id="password_confirmation" name="password_confirmation" placeholder="Confirmar Contraseña">
                    <span v-if="password_confirmationValid" class="text-danger validField"><b>El campo Confirmar Contraseña es requerido.</b></span>
                    <span v-if="password_compareValid" class="text-danger validField"><b>Las Contraseñas no coinciden</b></span>
                    <span v-if="passwordLength" class="text-danger validField"><b>La Contraseña de ser mayor 8 caracteres</b></span>
                  </div>
                </div>
                <div class="modal-footer">
                  <hr>
                  <button class="btn btn-sm btn-danger" type="button" @click="close"> <i class="fas fa-times fa-fw"></i>Cerrar</button>
                  <button type="submit" class="btn btn-sm btn-success"> <i class="fas fa-user-plus"></i> Registrar</button>
                </div>
              </form>
            </div>

          </b-overlay>
      </b-modal>
    </div>
  </template>

  <script>
  import 'bootstrap-vue/dist/bootstrap-vue.css';
  import { BModal, BOverlay } from 'bootstrap-vue';
  import rut from '../../../utils/rut';

  export default {
    components: {BModal, BOverlay},
    // props: ['record', 'showModal'],
    data() {
      return {
        loading: false,
        form: {
          first_name: '',
          last_name: '',
          documenttype_id: null,
          document_number: '',
          email: '',
          email_confirmation: '',
          password: '',
          password_confirmation: ''
        },
        documenttypes: [],
        //Validar campos
        first_nameValid: false,
        last_nameValid: false,
        documenttype_idValid: false,
        document_numberValid: false,
        document_numberRut: false,
        // País configurado; llega junto al catálogo de tipos de documento.
        country: null,
        // País cuyo documento se valida con módulo 11; lo dicta el backend.
        rutCountry: null,
        emailValid: false,
        email_confirmationValid: false,
        email_compareValid: false,
        passwordValid: false,
        password_confirmationValid: false,
        password_compareValid: false,
        //close modal
        modal: false,
        passwordType: '',
        passwordCType: '',
        passwordLength: false,
        userUsed: false,
        emailUsed: false,
        csrfToken: null,
        errorOccurred: false,
        mailSent: false
      }
    },
    mounted(){
      this.passwordType = "text";
      this.passwordCType = "text";
    },
    created(){
      this.csrfToken = document.querySelector('meta[name="csrf-token"]').getAttribute('content');
      this.getDocumenttypes();
    },
    computed: {
      /**
       * ¿Toca validar RUT? País configurado Chile Y tipo de documento que lo exige.
       */
      isRut() {
        const tipo = this.documenttypes.find(t => t.value === this.form.documenttype_id);
        return rut.isRutContext(this.country, tipo ? tipo.abbreviation : null, this.rutCountry);
      },
    },
    watch: {
      'form.document_number': function (value) {
        if (value === null || value === undefined) { return; }
        const next = this.isRut ? rut.maskInput(value) : rut.normalizeDocumentCase(value);
        if (next !== value) { this.form.document_number = next; }
      },
      'form.documenttype_id': function () {
        const value = this.form.document_number;
        if (!value) { return; }
        this.form.document_number = this.isRut ? rut.maskInput(value) : rut.normalizeDocumentCase(value);
      },
    },
    methods:{
      typeInput(){
        this.passwordType = this.form.password ? 'password' : 'text';
        this.passwordCType = this.form.password_confirmation ? 'password' : 'text';
      },
      getDocumenttypes(){
        axios.get('/register/documenttypes')
          .then(response => { this.documenttypes = response.data.data; this.country = response.data.country; this.rutCountry = response.data.rut_country; })
          .catch(error => { console.error(error) });
      },
      close(bvModalEvent) {
        //Clear field before close
        this.clearForm();
        this.passwordLength= false;
        this.modal= false;
        // OJO: el token NO se anula. Antes se ponía a null aquí y, al reabrir el
        // modal sin recargar, el POST viajaba con _token=null -> 419.
      },
      async submitForm() {

        this.first_nameValid= false;
        this.last_nameValid= false;
        this.documenttype_idValid= false;
        this.document_numberValid= false;
        this.emailValid= false;
        this.email_confirmationValid= false;
        this.email_compareValid= false;
        this.passwordValid= false;
        this.password_confirmationValid= false;
        this.password_compareValid= false;
        this.passwordLength= false;
        this.userUsed = false;
        this.emailUsed = false;
        this.errorOccurred= false;

        // Validar campos
        if (this.form.first_name == '' || this.form.first_name == null) {
          this.first_nameValid = true;
        }

        if (this.form.last_name == '' || this.form.last_name == null) {
          this.last_nameValid = true;
        }

        if (this.form.documenttype_id == '' || this.form.documenttype_id == null) {
          this.documenttype_idValid = true;
        }

        if (this.form.document_number == '' || this.form.document_number == null) {
          this.document_numberValid = true;
        }

        // Segunda barrera antes de enviar: la máscara puede no haberse aplicado si el
        // valor se fijó por código (autocompletado del navegador).
        this.document_numberRut = false;
        const rutCheck = rut.isValidForSubmit(this.form.document_number, this.isRut);
        if (!rutCheck.valid) {
          this.document_numberRut = true;
        }

        if (this.form.email == '' || this.form.email == null) {
          this.emailValid = true;
        }

        if (this.form.email_confirmation == '' || this.form.email_confirmation == null) {
          this.email_confirmationValid = true;
        }

        if (this.form.password == '' || this.form.password == null) {
          this.passwordValid = true;
        }

        if (this.form.password_confirmation == '' || this.form.password_confirmation == null) {
          this.password_confirmationValid = true;
        }

        // Si algún campo no es válido, detener el envío del formulario
        if (this.first_nameValid == true || this.last_nameValid == true || this.documenttype_idValid == true || this.document_numberValid == true || this.document_numberRut == true || this.emailValid == true || this.email_confirmationValid == true || this.passwordValid == true || this.password_confirmationValid == true) {
          return;
        }

        if (this.form.email != this.form.email_confirmation) {
          this.email_compareValid = true;
        }

        if (this.form.password != this.form.password_confirmation) {
          this.password_compareValid = true;
        }

        // Si algún campo de email o password no son iguales
        if (this.email_compareValid == true || this.password_compareValid == true) {
          return;
        }

        if (this.form.password.length <= 7) {
            this.passwordLength = true;
            return;
        }

        this.loading = true;

        let formData = new FormData();

        formData.append('_token', this.csrfToken);
        formData.append('first_name', this.form.first_name);
        formData.append('last_name', this.form.last_name);
        formData.append('documenttype_id', this.form.documenttype_id);
        formData.append('document_number', this.form.document_number);
        formData.append('email', this.form.email);
        formData.append('password', this.form.password);
        formData.append('password_confirmation', this.form.password_confirmation);

        await axios.post('/register/user', formData)
        .then(response => {
          this.errorOccurred = true;
          if (response.data.status == 'user') {
            this.userUsed = true;
            toastr.error(response.data.message, 'Error', { icon: 'fa fa-times-circle' });
          } else if (response.data.status == 'email') {
            this.emailUsed = true;
            toastr.error(response.data.message, 'Error', { icon: 'fa fa-times-circle' });
          } else if (response.data.status == 'error') {
            toastr.error(response.data.message, 'Error', { icon: 'fa fa-times-circle' });
          } else if (response.data.status == 'nomail') {
            // La cuenta SÍ se creó, pero el correo de activación no salió.
            // mailSent queda en false para NO decirle luego que revise su bandeja.
            toastr.warning(response.data.message, 'Cuenta creada', { icon: 'fa fa-exclamation-triangle' });
            this.errorOccurred = false;
            this.mailSent = false;
            this.clearForm();
          } else {
            toastr.success(response.data.message, 'Realizado', { icon: 'fa fa-check-circle' });
            this.errorOccurred = false;
            this.mailSent = true;
            this.clearForm();
          }
        })
        .catch(error => {
          console.error(error);
          this.errorOccurred = true;

          // El .catch heredado era mudo: un 422 y un 419 se veían igual.
          if (error.response && error.response.status === 422) {
            const bag = error.response.data.errors || {};
            const first = Object.keys(bag).length ? bag[Object.keys(bag)[0]][0] : 'Revisa los datos introducidos.';
            if (bag.email) this.emailUsed = true;
            if (bag.document_number) this.userUsed = true;
            toastr.error(first, 'Datos no válidos', { icon: 'fa fa-times-circle' });
          } else if (error.response && error.response.status === 419) {
            toastr.error('Tu sesión expiró. Recarga la página e inténtalo de nuevo.', 'Error', { icon: 'fa fa-times-circle' });
          } else {
            toastr.error('No se pudo guardar el registro', 'Error', { icon: 'fa fa-times-circle' });
          }
        })
        .finally(() => {
          this.loading = false;
          if (!this.errorOccurred) {
            setTimeout(() => {
                this.close();
                if (this.mailSent) {
                  toastr.warning("Confirma tu Correo Electrónico desde tu bandeja de entrada", 'Activar Cuenta', { icon: 'fa fa-check-circle' });
                }
              }, 2500);
          }
        });


      },
      clearForm(){
        this.form = {
          first_name: '',
          last_name: '',
          documenttype_id: null,
          document_number: '',
          email: '',
          email_confirmation: '',
          password: '',
          password_confirmation: ''
        };
        this.errorOccurred= false;
      },
    }
  }
  </script>